import { render } from "./OtpValidationView.vue?vue&type=template&id=ce4ec77c&ts=true"
import script from "./OtpValidationView.vue?vue&type=script&lang=ts"
export * from "./OtpValidationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__